import * as React from 'react';

import { ItemDetailRecord } from '@rematter/modules/settings/types/inventoryItem';
import { ContentCard } from '@rematter/ui-web';

import { ItemFormState } from '../../../_state/itemForm.state';

import { ItemDetailsForm } from './ItemDetailsForm';
import { ItemFormFooterActions } from './ItemFormFooterActions';

type Props = {
  item?: ItemDetailRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (data?: ItemFormState) => void;
  isSaving?: boolean;
};

export const ItemTabDetails: React.FC<Props> = ({
  item,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => (
  <div className="@ItemTabDetails flex max-h-full flex-col gap-5 p-5">
    <ContentCard className="p-0 pt-5">
      <ItemDetailsForm item={item} disabled={false} />
      <ItemFormFooterActions
        onSaveUpdates={onSaveUpdates}
        onDiscard={onDiscard}
        isSaving={isSaving}
      />
    </ContentCard>
  </div>
);
